import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-final-form';
import cn from 'classnames';
import Field from './Field/Field';
import { useTheme } from '../../../../../theme';
import InfoLinksLabel from '../../../../../InfoLinksLabel';
import { BaseButton } from '../../../../../BaseComponents';
import { validatePhone } from '@shared/lib/validate';
const ExchangeRefundCreateForm = ({ className, type, title, description, initialValues, buttonText, isLoading, requiredComment, order, onSubmit }) => {
    const { ExchangeRefundCreateForm: theme } = useTheme('Entities').Order;
    const { t } = useTranslation('CreateRequest');
    const formValues = Object.assign({}, initialValues);
    formValues.phone = validatePhone(formValues.phone);
    const handleOnSubmit = (data) => {
        onSubmit({
            name: data.name || '',
            email: data.email || '',
            phone: data.phone || '',
            comment: data.comment || ''
        });
    };
    return (React.createElement(Form, { onSubmit: handleOnSubmit, initialValues: formValues }, ({ handleSubmit, valid }) => (React.createElement("form", { className: theme.form, onSubmit: handleSubmit },
        React.createElement("div", { className: cn(theme.fields, className) },
            React.createElement("div", { className: theme.header },
                React.createElement("div", { className: theme.title }, title !== null && title !== void 0 ? title : t('Your contacts')),
                !!description && React.createElement("div", { className: theme.description }, description)),
            React.createElement("div", { className: theme.contacts },
                React.createElement(Field, { name: "name", type: "text", label: t('Your name'), className: theme.field }),
                React.createElement(Field, { name: "email", type: "email", label: t('Your email'), className: theme.field }),
                React.createElement(Field, { name: "phone", type: "phone", label: t('Your phone'), className: theme.field, displayInitialValueAsLocalNumber: false })),
            React.createElement(Field, { name: "comment", type: "comment", label: t('Your comments'), className: cn(theme.field, theme.field__comment), required: requiredComment })),
        React.createElement("div", { className: theme.controls },
            React.createElement(Field, { name: "acceptTerm", type: "checkbox", label: React.createElement(InfoLinksLabel, { className: theme.label, order: order, type: type }) }),
            React.createElement(BaseButton, { variant: "action", type: "submit", className: theme.submit, isLoading: isLoading, disabled: !valid, "data-next-button": true }, buttonText !== null && buttonText !== void 0 ? buttonText : t('Send request')))))));
};
export default ExchangeRefundCreateForm;
